/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import { store } from 'react-notifications-component';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutSimple from '../components/LayoutSimple.jsx';
import NavigatorFoto from '../components/NavigatorFoto.jsx';
import Button from '../components/Button.jsx';
import MapPreview from '../components/MapPreview.jsx';
import LoadingModal from '../components/LoadingModal';

import { postRequest, simpleGetRequest, downloadRequestGET } from '../service/ApiService';
import { getPNOADate } from '../service/Maths';
import LocalStorage from '../service/LocalStorage';

import {createTheme} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {ThemeProvider} from '@material-ui/styles';

import {properties} from '../resources/properties.js';
import i18n from '../resources/i18n';

import LOGO from '../img/Comunes/Logo_img01.png';//'../img/Comunes/img01.png'; //logo portada bot
import LOGO_MAC_N from '../img/Comunes/img02.png'; //logo MAC top
import LOGO_MAC_S_M from '../img/Comunes/img02_special_map.png'; //Logo MAC Especial MTN
import LOGO_MAC_S_I from '../img/Comunes/img02_special_img.png'; //Logo MAC Especial IMAGE

declare var M;
declare var ol;
const pluginListPreview = [new M.plugin.Mapaalacarta({enabled: false, posterMode: true})];

const sizeImageCustomUnit = (properties.MAX_POST_SIZE / 1048576 >= 1)
  ? (Math.round(properties.MAX_POST_SIZE / 1048576) + ' MB')
  : (Math.round(properties.MAX_POST_SIZE / 1024) + ' KB');

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

let API_URL = properties.apiURLApiService;
if (window.location.protocol === 'https:' && API_URL.includes('http://'))
  API_URL = API_URL.replace('http://', 'https://');
else if (window.location.protocol === 'http:' && API_URL.includes('https://'))
  API_URL = API_URL.replace('https://', 'http://');

class Step2F extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfCopies: "1",
      paperType: "FotoNormalsinplegar",
      totalPrice: '',
      isLoaded: true,
      urlPDF: undefined,
      showModal: false,
      showModalBarCode: false,
      showAlertModal: false,
      showModalDownload: false,
      showModalCart: false,
      showModalRedirect: false,
      condiciones: false,
      showSnackbar: false,
      showSnackbarTypeURL: true,
      petition: 'PDF',
      isTourOpen: false,
      includeLinearProgress: true,
    };
    this.previuslyAddedToCart = {};
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShowBarCode = this.handleShowBarCode.bind(this);
    this.handleCloseBarCode = this.handleCloseBarCode.bind(this);
    this.handleCloseDownload = this.handleCloseDownload.bind(this);
    this.handleOpenCart = this.handleOpenCart.bind(this);
    this.handleCloseCart = this.handleCloseCart.bind(this);
    this.handleOpenRedirect = this.handleOpenRedirect.bind(this);
    this.handleCloseRedirect = this.handleCloseRedirect.bind(this);
    this.doPriceRequest(this.state.paperType, this.state.numberOfCopies);

    this.blockColor = true;
    this.showSpan = true;
    this.rotateBarcode = this.props.parentState.orientation === 'Retrato';//Special_posterPortrait: Special_reportPosterPortrait.jrxml
    if (this.props.parentState.specialMapGeneration) {
      if(this.rotateBarcode && this.props.parentState.codigoBarras){
        this.saveVerticalBarCode();
      } else {
        this.props.parentState.realCodigoBarras = this.props.parentState.codigoBarras;
      }
      if(props.parentState.seleccionadoProductoSeries === 'Foto'){
        this.LOGO_MAC = LOGO_MAC_S_I;
      }else{
        this.LOGO_MAC = LOGO_MAC_S_M;
      }
    } else {
      this.LOGO_MAC = LOGO_MAC_N;//Logos WEB apropiados segun Mapa Especial
    }
    let pluginAux = this.props.parentState.mapa.getPlugins().find(plugin => plugin.name === "EditionTools");
    if(pluginAux){
      let legendToGenerate = pluginAux.getLegendToSend();
      if(legendToGenerate){
        const expectedSize = props.parentState.orientation === 'Paisaje' ? properties.FO_OR_POST_SLEY_LAND: properties.FO_OR_POST_SLEY_PORT;
        if(props.parentState.orientation === 'Retrato'){
          this.pluginLegend = (<div id="pluginLegend" className={legendToGenerate.type}  dangerouslySetInnerHTML={{__html: legendToGenerate.svg}} style={{
            width: (Number.parseInt(legendToGenerate.svg.match(/width="(\d+)"/)[1])*100/expectedSize.height).toFixed(4)+"%",
            height: (Number.parseInt(legendToGenerate.svg.match(/height="(\d+)"/)[1])*100/expectedSize.width).toFixed(4)+"%"
          }}></div>);
        } else {
          this.pluginLegend = (<div id="pluginLegend" className={legendToGenerate.type}  dangerouslySetInnerHTML={{__html: legendToGenerate.svg}} style={{
            width: (Number.parseInt(legendToGenerate.svg.match(/width="(\d+)"/)[1])*100/expectedSize.width).toFixed(4)+"%",
            height: (Number.parseInt(legendToGenerate.svg.match(/height="(\d+)"/)[1])*100/expectedSize.height).toFixed(4)+"%"
          }}></div>);
        }
      }
    }
  }

  handleChangeImageBarras = (event) => {
    let {parentState} = this.props;
    let reader = new FileReader();
    let file = event.target.files[0];
    if (file.size > properties.MAX_POST_SIZE) {
      event.target.value = null;
      this.handleShowBarCode();
      return;
    }
    parentState.specialFileName = file.name;
    let img = new Image();
    reader.onload = (upload) => {
      if(this.rotateBarcode){
        this.saveVerticalBarCode(upload.target.result);
      }
      img.src = upload.target.result;
    };
    img.onload = () => {
      this.blockColor = false;
      this.showSpan = false;
      var oc = document.createElement('canvas'),
      octx = oc.getContext('2d');
      oc.width = img.width;
      oc.height = img.height;
      octx.drawImage(img, 0, 0, oc.width, oc.height);
      parentState.codigoBarras = oc.toDataURL();
      if(!this.rotateBarcode){
        parentState.realCodigoBarras = parentState.codigoBarras;
      }
      this.setState({urlPDF: undefined}); // Force regenerate
      this.setStateGlobal(parentState);
    }
    reader.readAsDataURL(file);
  }

  clearCodigoBarras = (event) => {
    let {parentState} = this.props;
    this.blockColor = true;
    this.showSpan = true;
    event.target.parentElement.childNodes[0].value = null;
    event.target.parentElement.childNodes[0].files = null;
    parentState.codigoBarras = null;
    parentState.realCodigoBarras = null;
    parentState.specialFileName = null;
    this.setState({});
  }

  saveVerticalBarCode(url){
    let {parentState} = this.props;
    let imgVertical = new Image();
    imgVertical.src = url || parentState.codigoBarras;
    imgVertical.onload = () => {
      var ocVertical = document.createElement('canvas'),
      octxVertical = ocVertical.getContext('2d');
      ocVertical.width = imgVertical.height;
      ocVertical.height = imgVertical.width;
      ocVertical.style.position = "absolute";
      octxVertical.translate(imgVertical.height / 2, imgVertical.width / 2);
      octxVertical.rotate(Math.PI / 2);
      octxVertical.translate(-imgVertical.width / 2, -imgVertical.height / 2);
      octxVertical.drawImage(imgVertical, 0, 0, ocVertical.height, ocVertical.width);
      parentState.realCodigoBarras = ocVertical.toDataURL();
    }
  }

  functionUpdatePrice = (event) => {
    let paperType, totalPrice;
    switch (event.target.name) {
      case "Normal":
        paperType = 'FotoNormalsinplegar';
        break;
      case "Fotografico":
        paperType = 'Fotograficosinplegar';
        break;
      case "Rigido":
        paperType = 'FotoRigidosinplegar';
        break;
      case "Aventura":
          paperType = 'FotoAventurasinplegar';
          break;
      default:
        paperType = 'FotoNormalsinplegar'
        break;
    }

    totalPrice = this.doPriceRequest(paperType, this.state.numberOfCopies);
  }

  functionUpdateCopies = (event) => {
    let copies = event.target.value;
    let totalPrice = Math.round((parseFloat(this.state.totalPrice) / parseFloat(this.state.numberOfCopies)) * parseFloat(copies) * 100) / 100;
    this.setState({numberOfCopies: copies, totalPrice: totalPrice});
  }

  setStateGlobal = (parentState) => {
    const {setParentState} = this.props;

    setParentState(parentState);
  }
  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  getIdMAC = () => { // genera el ID del PDF (fecha + random + tipo producto)
    const dateParts = new Intl.DateTimeFormat("es-ES", {
      timeZone: "Europe/Madrid",
      year: "2-digit",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date());

    const yy = dateParts.find(p => p.type === "year").value;
    const mm = dateParts.find(p => p.type === "month").value;
    const dd = dateParts.find(p => p.type === "day").value;

    return yy
      + mm
      + dd + "-"
      + Math.floor(Math.random() * 1000000000).toString().padStart(9, "0")
      + "-F"; 
  }

  doPriceRequest(tipoDePapel, cantidad) {
    const allTypes = properties.TIPOS_DE_PAPEL_COMPRA;
    let url = '/conectorMAC/getPrices?';
    url += tipoDePapel + '=' + cantidad;
    allTypes.filter((x) => x !== tipoDePapel).forEach((tipo) => {
      url += '&' + tipo + '=0';
    });

    simpleGetRequest(url).then(response => {
      let responseData = JSON.parse(JSON.stringify(response.data));
      this.setState({paperType: tipoDePapel, totalPrice: responseData.totalsiniva});
    }).catch(() => console.warn('ERROR price request'));
  }

  handleClose() {
    this.setState({showModal: false});
  }

  checkValidityNot(){
    let notValid = false;
    if (!document.getElementById('textAuthor').validity.valid) {
      document.getElementById('textAuthor').style.borderBottomColor = '#ff0000';
      notValid = true;
    } else {
      document.getElementById('textAuthor').style.borderBottomColor = 'black';
    }
    if (!document.getElementById('titleStep2').validity.valid) {
      document.getElementById('titleStep2').style.borderBottomColor = '#ff0000';
      notValid = true;
    } else {
      document.getElementById('titleStep2').style.borderBottomColor = 'black';
    }

    if (this.props.parentState.specialMapGeneration){
      if (!document.getElementById('imagenCodigoBarras').validity.valid) {
        document.getElementById('imagenCodigoBarras').style.borderBottomColor = '#ff0000';
        notValid = true;
      } else {
        document.getElementById('imagenCodigoBarras').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textDepositoLegal').validity.valid) {
        document.getElementById('textDepositoLegal').style.borderBottomColor = '#ff0000';
        notValid = true;
      } else {
        document.getElementById('textDepositoLegal').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textISBN').validity.valid) {
        document.getElementById('textISBN').style.borderBottomColor = '#ff0000';
        notValid = true;
      } else {
        document.getElementById('textISBN').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textNipo').validity.valid) {
        document.getElementById('textNipo').style.borderBottomColor = '#ff0000';
        notValid = true;
      } else {
        document.getElementById('textNipo').style.borderBottomColor = 'black';
      }
    }
    return notValid;
  }

  handleShow() {
    if (this.checkValidityNot()) {
      this.setState({showAlertModal: true});
    } else {
      this.setState({showModal: true});
    }
  }

  handleCloseDownload() {
    this.setState({showModalDownload: false});
  }

  handleOpenCart() {
    this.setState({showModalCart: true});
  }
  handleCloseCart() {
    this.setState({showModalCart: false});
  }
  handleOpenRedirect() {
    this.setState({showModalRedirect: true});
  }
  handleCloseRedirect() {
    this.setState({showModalRedirect: false});
  }

  handleShowBarCode() {
    this.setState({showModalBarCode: true});
  }
  handleCloseBarCode() {
    this.setState({showModalBarCode: false});
  }

  async doRequest(parentState, conversorPDF) {
    if (this.state.urlPDF !== undefined) {
      this.setState({petition: 'PDF', includeLinearProgress: true, showModalDownload: true, showModal: false, isLoaded: true});
    } else {
      let date;
      let id = this.getIdMAC();//this.state.paperType, this.state.numberOfCopies
      conversorPDF.attributes.frameColor = this.props.parentState.frameColor;
      if (conversorPDF.attributes.agradecimientos !== undefined && conversorPDF.attributes.agradecimientos.length > 2) {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0] + ' - ' + id;
      }

      this.setState({petition: 'PDF', includeLinearProgress: true, showModal: false, isLoaded: false, text: this.loaderAltaRes});
      const extent = new ol.geom.MultiPolygon(parentState.centroidSheet[0].getGeometry().coordinates).getExtent();
      getPNOADate(extent).then((dateResponse) => {
        const resJSON = dateResponse.data;
        if (resJSON.features.length > 0) {
          date = resJSON.features[0].properties.Fecha;
          conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split('***DATE***').join(date);
        } else {
          conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' Fecha de vuelo ***DATE***.').join('');
        }

        this.innerDoRequest(conversorPDF, id);
      }).catch((err) => {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' Fecha de vuelo ***DATE***.').join('');
        this.innerDoRequest(conversorPDF, id);
      });
    }
  }

  innerDoRequest = (conversorPDF, id) => {
    let urlPDF;
    const headers = {};
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    postRequest('/conectorMAC/PrintPDF?printID=' + id, conversorPDF, headers).then(response => {
      clearInterval(window.timer);
      if (typeof response.data === 'string' && response.data.indexOf('error') === -1) {
        this.savedAt = new Date().getTime();
        urlPDF = '/conectorMAC/getPDFByID?printID=' + id;
        this.setState({
          petition: 'PDF',
          showModalDownload: true,
          idPedido: id,
          isLoaded: true,
          urlPDF: API_URL + urlPDF
        });
      } else {
        const component = <div className='notification-content notification-info'>
          <div className='notification-close'></div>
          <p className='notification-message'>
            <span>
              {i18n.t('step2.error_pdf_1')}.<br/>
              {i18n.t('step2.error_pdf_2')}: {response.data.message}<br/>
              {i18n.t('step2.error_pdf_3')}: {id}<br/>
            </span>
            <span dangerouslySetInnerHTML={{__html: i18n.t('step2.error_pdf_4')}} />
          </p>
        </div>;

        this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
        store.addNotification({
          id: 'print-notification',
          type: 'danger',
          insert: 'top',
          content: component,
          container: 'center',
          animationIn: ['animated', 'fadeIn'],
          dismiss: {
            duration: 0,
            click: false,
            touch: false,
          },
        });

        this.addCloseNotificationEvent();
      }
    }).catch(err => {
      const component = <div className='notification-content notification-info'>
        <div className='notification-close'></div>
        <p className='notification-message'>
          <span>
            <br/>
            {i18n.t('step2.error_pdf_1')}.<br/>
            <br/>
          </span>
        </p>
      </div>;

      clearInterval(window.timer);
      this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
      store.addNotification({
        id: 'print-notification',
        type: 'danger',
        insert: 'top',
        content: component,
        container: 'center',
        animationIn: ['animated', 'fadeIn'],
        dismiss: {
          duration: 0,
          click: false,
          touch: false,
        },
      });

      this.addCloseNotificationEvent();
    });
  }

  addAndRedirectToCart(searchItem, tipoImpresion, cantidad, urlPDF, items){
    if(!searchItem){//CHECK if duplicate //Si ya existe en carrito este mismo apartado, pues no se añade antes de la redirreción
      const price = parseFloat(document.querySelector('.price div > label').innerText.trim()) / cantidad;
      const item = {
        type: tipoImpresion,
        quantity: cantidad,
        url: urlPDF,
        title: this.props.parentState.title,
        subtitle: this.props.parentState.subtitle,
        id: urlPDF.split('?printID=')[1],
        price: price,
        savedAt: this.savedAt,
      };
      items.push(item);
      LocalStorage.put('mac-items', items);
    }
    window.location.href = '/mapaalacarta/ShoppingCart';
  }

  async tiendaVirtual(estado) {
    if (this.checkValidityNot()) {
      this.setState({showAlertModal: true});
      return;
    }

    let date;
    const tipoImpresion = estado.paperType;
    const cantidad = estado.numberOfCopies;
    this.setState({petition: 'PDF', isLoaded: false, includeLinearProgress: true, text: this.loaderAltaRes});
    if (estado.urlPDF !== undefined) {
      const urlPDF = estado.urlPDF;
      const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];//Check group buy
      if(items.length === 0){//Send to store
        simpleGetRequest('/conectorMAC/urlCompra?tipoImpresion=' + tipoImpresion + '&cantidad=' + cantidad + '&urlPDF=' + urlPDF).then(response => {
          let responseData = JSON.parse(JSON.stringify(response.data));
          window.open(responseData.url, "_self");
          this.setState({petition: 'PDF', isLoaded: true, urlPDF: urlPDF});
        });
      } else {//Send to cart
        const searchItem = items.find(item=>{return item.type === tipoImpresion && item.url === urlPDF && item.title === this.props.parentState.title && item.subtitle === this.props.parentState.subtitle})
        this.addAndRedirectToCart(searchItem, tipoImpresion, cantidad, urlPDF, items);
      }
    } else {
      const conversorPDF = this.props.conversorPDF;
      const parentState = this.props.parentState;
      let id = this.getIdMAC();//this.state.paperType, this.state.numberOfCopies
      conversorPDF.attributes.frameColor = parentState.frameColor;
      if (conversorPDF.attributes.agradecimientos !== undefined && conversorPDF.attributes.agradecimientos.length > 2) {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0] + ' - ' + id;
      }

      const extent = new ol.geom.MultiPolygon(parentState.centroidSheet[0].getGeometry().coordinates).getExtent();
      getPNOADate(extent).then((dateResponse) => {
        const resJSON = dateResponse.data;
        if (resJSON.features.length > 0) {
          date = resJSON.features[0].properties.Fecha;
          conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split('***DATE***').join(date);
        } else {
          conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' Fecha de vuelo ***DATE***.').join('');
        }

        this.innerTiendaVirtual(conversorPDF, id, tipoImpresion, cantidad);
      }).catch((err) => {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' Fecha de vuelo ***DATE***.').join('');
        this.innerTiendaVirtual(conversorPDF, id, tipoImpresion, cantidad);
      });
    }
  }

  innerTiendaVirtual = (conversorPDF, id, tipoImpresion, cantidad) => {
    let urlPDF;
    const headers = {};
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    postRequest('/conectorMAC/PrintPDF?printID=' + id, conversorPDF, headers).then(response => {
      if (typeof response.data === 'string' && response.data.indexOf('error') === -1) {
        this.savedAt = new Date().getTime();
        urlPDF = API_URL + '/conectorMAC/getPDFByID?printID=' + id;
        const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];//Check group buy
        if(items.length === 0){//Send to store
          simpleGetRequest('/conectorMAC/urlCompra?tipoImpresion=' + tipoImpresion + '&cantidad=' + cantidad + '&urlPDF=' + urlPDF).then(response => {
            let responseData = JSON.parse(JSON.stringify(response.data));
            window.open(responseData.url, "_self");
            if (!urlPDF.includes(API_URL)) {
              urlPDF = API_URL + urlPDF;
            }
            this.setState({petition: 'PDF', isLoaded: true, urlPDF: urlPDF, idPedido: id});
          });
        } else {//Send to cart
          const searchItem = items.find(item=>{return item.type === tipoImpresion && item.url === urlPDF && item.title === this.props.parentState.title && item.subtitle === this.props.parentState.subtitle})
          this.addAndRedirectToCart(searchItem, tipoImpresion, cantidad, urlPDF, items);
        }
      } else {
        const component = <div className='notification-content notification-info'>
          <div className='notification-close'></div>
          <p className='notification-message'>
            <span>
              {i18n.t('step2.error_pdf_1')}.<br/>
            {i18n.t('step2.error_pdf_2')}: {response.data.message}<br/>
              {i18n.t('step2.error_pdf_3')}: {id}<br/>
            </span>
            <span dangerouslySetInnerHTML={{__html: i18n.t('step2.error_pdf_4')}} />
          </p>
        </div>;

        this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
        store.addNotification({
          id: 'print-notification',
          type: 'danger',
          insert: 'top',
          content: component,
          container: 'center',
          animationIn: ['animated', 'fadeIn'],
          dismiss: {
            duration: 0,
            click: false,
            touch: false,
          },
        });

        this.addCloseNotificationEvent();
      }
    }).catch(err => {
      const component = <div className='notification-content notification-info'>
        <div className='notification-close'></div>
        <p className='notification-message'>
          <span>
            <br/>
            {i18n.t('step2.error_pdf_1')}.<br/>
            <br/>
          </span>
        </p>
      </div>;

      clearInterval(window.timer);
      this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
      store.addNotification({
        id: 'print-notification',
        type: 'danger',
        insert: 'top',
        content: component,
        container: 'center',
        animationIn: ['animated', 'fadeIn'],
        dismiss: {
          duration: 0,
          click: false,
          touch: false,
        },
      });

      this.addCloseNotificationEvent();
    });
  }

  async addToShoppingCart(estado) {
    if (this.checkValidityNot()) {
      this.setState({showAlertModal: true});
      return;
    }
    this.previuslyAddedToCart[this.state.paperType] = true;
    const tipoImpresion = estado.paperType;
    const cantidad = estado.numberOfCopies;
    if (estado.urlPDF !== undefined) {
      const urlPDF = estado.urlPDF;
      const title = document.querySelector('input[name="textTitle"]').value.trim();
      const subtitle = document.querySelector('input[name="textSubtitle"]').value.trim();
      const price = parseFloat(document.querySelector('.price div > label').innerText.trim()) / cantidad;
      const item = {
        type: tipoImpresion,
        quantity: cantidad,
        url: urlPDF,
        title: title,
        subtitle: subtitle,
        id: urlPDF.split('?printID=')[1],
        price: price,
        savedAt: this.savedAt,
      };

      const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];
      if(items.length > 0){
        const findSimilarItem = items.find(i=>i.type === item.type && i.id === item.id && i.subtitle === item.subtitle);
        if(findSimilarItem){
          findSimilarItem.quantity = (Number.parseInt(findSimilarItem.quantity) + Number.parseInt(item.quantity)).toFixed();
        }else{
          items.push(item);
        }
      }else{
        items.push(item);
      }
      LocalStorage.put('mac-items', items);
      this.props.parentState.callback();
      this.handleOpenRedirect();
    } else {
      let date;
      this.setState({petition: 'PDF', isLoaded: false, includeLinearProgress: true, text: this.loaderAltaRes});
      const conversorPDF = this.props.conversorPDF;
      const parentState = this.props.parentState;
      let id = this.getIdMAC();//this.state.paperType, this.state.numberOfCopies
      conversorPDF.attributes.frameColor = parentState.frameColor;
      if (conversorPDF.attributes.agradecimientos !== undefined && conversorPDF.attributes.agradecimientos.length > 2) {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0] + ' - ' + id;
      }

      const extent = new ol.geom.MultiPolygon(parentState.centroidSheet[0].getGeometry().coordinates).getExtent();
      getPNOADate(extent).then((dateResponse) => {
        const resJSON = dateResponse.data;
        if (resJSON.features.length > 0) {
          date = resJSON.features[0].properties.Fecha;
          conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split('***DATE***').join(date);
        } else {
          conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' Fecha de vuelo ***DATE***.').join('');
        }

        this.innerShoppingCart(conversorPDF, id, tipoImpresion, cantidad);
      }).catch((err) => {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' Fecha de vuelo ***DATE***.').join('');
        this.innerShoppingCart(conversorPDF, id, tipoImpresion, cantidad);
      });
    }
  }

  innerShoppingCart = (conversorPDF, id, tipoImpresion, cantidad) => {
    const headers = {};
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    postRequest('/conectorMAC/PrintPDF?printID=' + id, conversorPDF, headers).then(response => {
      if (typeof response.data === 'string' && response.data.indexOf('error') === -1) {
        this.savedAt = new Date().getTime();
        const urlPDF = API_URL + '/conectorMAC/getPDFByID?printID=' + id;
        const title = document.querySelector('input[name="textTitle"]').value.trim();
        const subtitle = document.querySelector('input[name="textSubtitle"]').value.trim();
        const price = parseFloat(document.querySelector('.price div > label').innerText.trim()) / cantidad;
        const item = {
          type: tipoImpresion,
          quantity: cantidad,
          url: urlPDF,
          title: title,
          subtitle: subtitle,
          id: id,
          price: price,
          savedAt: this.savedAt,
        };

        const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];
      if(items.length > 0){
        const findSimilarItem = items.find(i=>i.type === item.type && i.id === item.id && i.subtitle === item.subtitle);
        if(findSimilarItem){
          findSimilarItem.quantity = (Number.parseInt(findSimilarItem.quantity) + Number.parseInt(item.quantity)).toFixed();
        }else{
          items.push(item);
        }
      }else{
        items.push(item);
      }
      LocalStorage.put('mac-items', items);
      this.setState({ petition: 'PDF', isLoaded: true, urlPDF: urlPDF, idPedido: id }, () => {
        this.props.parentState.callback();
      });
      this.handleOpenRedirect();
      } else {
        const component = <div className='notification-content notification-info'>
          <div className='notification-close'></div>
          <p className='notification-message'>
            <span>
              {i18n.t('step2.error_pdf_1')}.<br/>
            {i18n.t('step2.error_pdf_2')}: {response.data.message}<br/>
              {i18n.t('step2.error_pdf_3')}: {id}<br/>
            </span>
            <span dangerouslySetInnerHTML={{__html: i18n.t('step2.error_pdf_4')}} />
          </p>
        </div>;

        this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
        store.addNotification({
          id: 'print-notification',
          type: 'danger',
          insert: 'top',
          content: component,
          container: 'center',
          animationIn: ['animated', 'fadeIn'],
          dismiss: {
            duration: 0,
            click: false,
            touch: false,
          },
        });

        this.addCloseNotificationEvent();
        this.previuslyAddedToCart[this.state.paperType] = false;
      }
    }).catch(err => {
      const component = <div className='notification-content notification-info'>
        <div className='notification-close'></div>
        <p className='notification-message'>
          <span>
            <br/>
            {i18n.t('step2.error_pdf_1')}.<br/>
            <br/>
          </span>
        </p>
      </div>;

      clearInterval(window.timer);
      this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
      store.addNotification({
        id: 'print-notification',
        type: 'danger',
        insert: 'top',
        content: component,
        container: 'center',
        animationIn: ['animated', 'fadeIn'],
        dismiss: {
          duration: 0,
          click: false,
          touch: false,
        },
      });

      this.addCloseNotificationEvent();
      this.previuslyAddedToCart[this.state.paperType] = false;
    });
  }

  componentWillUnmount(){
    if(this.notificationListenerFunction){
      let auxNotif = document.querySelector('.notification-close');
      if(auxNotif) auxNotif.removeEventListener('click', this.notificationListenerFunction);
    }
  }

  addCloseNotificationEvent = () => {
    setTimeout(() => {
      this.notificationListenerFunction = () => {store.removeNotification('print-notification');};
      document.querySelector('.notification-close').addEventListener('click', this.notificationListenerFunction);
    }, 100);
  }

  handleCloseSnackbar() {
    this.setState({showSnackbar: false});
  }

  handleShowSnackbar(type) {
    this.setState({showSnackbar: true, showSnackbarTypeURL: type});
  }
  downloadPDF(urlPDF, id) {
    const headers = {};
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    if (!urlPDF.includes(API_URL)) {urlPDF = API_URL + urlPDF;}
    this.setState({showModalDownload: false, showModal: false, includeLinearProgress: false, isLoaded: false, text: this.loaderWait});
    downloadRequestGET(urlPDF, headers, "blob").then(response => response.blob()).then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = id + ".pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      clearInterval(window.timer);
      this.setState({petition: 'PDF',  showModalDownload: false, showModal: false, isLoaded: true, urlPDF: urlPDF, idPedido: id});
    }).catch(error =>{
      console.error(error);
      clearInterval(window.timer);
      this.setState({petition: 'PDF',  showModalDownload: false, showModal: false, isLoaded: true, urlPDF: urlPDF, idPedido: id});
    });
  }

  copyToClipBoard = (str) => {
    const elementToCopy = document.getElementById('urlPDF');
    const selecction = document.createRange();
    selecction.selectNodeContents(elementToCopy);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(selecction);
    document.execCommand('copy');
    window.getSelection().removeRange(selecction);
  }

  setText = (event) => {
    let {parentState} = this.props;

    switch (event.target.name) {
      case 'textTitle':
        parentState.title = event.target.value;
        break;
      case 'textSubtitle':
        parentState.subtitle = event.target.value;
        break;
      case 'textAuthor':
        if (!parentState.specialMapGeneration) {
          parentState.author = event.target.value;
        }
        break;
//Mapa Especial
      case 'textNipo':
        parentState.nipo = event.target.value;
        break;
      case 'textISBN':
        parentState.isbn = event.target.value;
        break;
      case 'textDepositoLegal':
        parentState.depositoLegal = event.target.value;
        break;
//Mapa Especial
      default:
        parentState.title = event.target.value;
    }
    this.setState({urlPDF: undefined}); // Force regenerate
    this.setStateGlobal(parentState);
  }

  handleInputChange = (event) => {

    const target = event.target;
    const value = target.type === 'checkbox'
      ? target.checked
      : target.value;
    const name = target.name;

    this.setState({[name]: value});

  }

  handleCloseWizard = () => {
    this.setState({showAlertModal: false});
  }

  setFrameColor = (event) => {
    let {parentState} = this.props;
    let previusFrameColor = parentState.frameColor;
    switch (event.target.name) {
      case 'marco_BLUE':
        parentState.frameColor = '#184962';
        break;
      case 'marco_RED':
        parentState.frameColor = '#952616';
        break;
      case 'marco_ORANGE':
        parentState.frameColor = '#f7a941';
        break;
      case 'marco_GREEN':
        parentState.frameColor = '#00a75d';
        break;
      case 'marco_GREY':
        parentState.frameColor = '#858584';
        break;
      case 'marco_BROWN':
        parentState.frameColor = '#946a43';
        break;
      case 'marco_CYAN':
        parentState.frameColor = '#5db3ae';
        break;
      case 'marco_PURPLE':
        parentState.frameColor = '#985fa4';
        break;
      //case 'marco_LIGHT_GREY':parentState.frameColor = '#E5E5E5';break;
      case 'marco_WHITE':
        parentState.frameColor = '#FFFFFF';
        break;
      default:
        parentState.frameColor = '#FFFFFF';
    }
    if (previusFrameColor !== parentState.frameColor) this.setState({urlPDF: undefined}); // Force regenerate
    this.setStateGlobal(parentState);
  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  render() {
    const {parentState, conversorPDF} = this.props;//, conversorPNG
    const isTourOpen = this.state.isTourOpen;

    const steps = [
      {
        selector: '.bg-color',
        content: i18n.t('tour.step3FFirstStep'),
      },
      {
        selector: '.texts-wizardPanel-step3',//highlightedSelectors: ['.secondHelpStep', '.firstHelpStep']
        content: parentState.specialMapGeneration ? i18n.t('tour.step3PFirstPointTwoStepSpecial') : i18n.t('tour.step3PFirstPointTwoStep'),
      },
      {
        selector: '.map-preview',
        content: i18n.t('tour.step3SecondStep'),
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.description-condiciones',
        content: i18n.t('tour.step3FourthStep'),
      },
      {
        selector: '.download',
        content: i18n.t('tour.step3FifthStep'),
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.step3-paper-type',
        content: i18n.t('tour.step3SixthStepFoto'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.price',
        content: i18n.t('tour.step3EighthStep'),
      }
    ].filter(Boolean);

    this.loaderAltaRes = i18n.t('step3.loaderAltaRes');
    this.loaderWait = i18n.t('step3.loaderWait');

    let aspectRatioClass;
    if(parentState.orientation === 'Paisaje'){
      if(parentState.posterLegend){
        if(parentState.scale === "1:40.000" || parentState.scale === "1:50.000"|| parentState.scale === "1:60.000"){
          aspectRatioClass = 'aspectRatioPoster_L_HIGH';
        } else {
          aspectRatioClass = 'aspectRatioPoster_L';
        }
      } else {
        if(parentState.seleccionadoProductoSeries === 'Elaborado'){//if(parentState.active< 6){
          aspectRatioClass = 'aspectRatioLandscape';
        }else{
          aspectRatioClass = 'aspectRatioPoster';
        }
        if(parentState.verticalCartela){
          aspectRatioClass = 'aspectRatioLandscape_R';
        }
      }
    } else {
      if(parentState.posterLegend){
        aspectRatioClass = 'aspectRatioPosterPortrait_L';
      } else {
        if(parentState.seleccionadoProductoSeries === 'Elaborado'){//if(parentState.active< 6){
          aspectRatioClass = 'aspectRatioPortrait';
        }else{
          aspectRatioClass = 'aspectRatioPosterPortrait';
        }
        if(parentState.verticalCartela){
          aspectRatioClass = 'aspectRatioPortrait_R';
        }
      }
    }

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar bg-active';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle bg-active';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name active';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar bg-active';

    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle bg-active';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name active';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = 'step3'
    //const sectionFrontClassName = 's3-left-front';
    const sectionClassName = 's3-left-map';
    const asideClassName = 's3-right';

    //SnackBar
    const snackBarURL = i18n.t('dialog.snackBarURL');
    const snackBarID = i18n.t('dialog.snackBarID');

    //Textos
    //const title = i18n.t('step2.title')+"*";
    //const subtitle = i18n.t('step2.subtitle');
    //const author = i18n.t('step2.author')+"*";

    const {totalPrice} = this.state;
    let placeholderFile;
    if(parentState){
      placeholderFile = (parentState.codigoBarras? (parentState.specialFileName?parentState.specialFileName:i18n.t('step2.selectedFile')) :i18n.t('step2.notSelectedFile')) || (parentState.codigoBarras ? 'Archivo previamente seleccionado.' : 'Archivo no seleccionado.');
    } else {
      placeholderFile = parentState.codigoBarras ? (parentState.specialFileName?parentState.specialFileName:'Archivo previamente seleccionado.') : 'Archivo no seleccionado.';
    }

    let traduccionInputs;
    if(parentState && parentState.specialMapGeneration){//Especial
      traduccionInputs = i18n.t('dialog.textFormError1Especial') || 'Para completar mapa especial, debe introducir el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras.';
    } else {
      traduccionInputs = i18n.t('dialog.textFormError1') || 'Para completar el mapa debe introducir el título y el autor/a.';
    }

    return (<LayoutSimple setParentStateSteps={this.setStateGlobal} parentState={parentState} isStep3={1}>
      <Snackbar anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }} onClose={this.handleCloseSnackbar.bind(this)} open={this.state.showSnackbar} autoHideDuration={1500} message={this.state.showSnackbarTypeURL?snackBarURL:snackBarID}/>
      <LoadingModal style={this.state.isLoaded === true ? "none" : true}
        text={this.state.isLoaded === true ? "" : this.state.text} classNameText={this.state.isLoaded === true ? "" : "loadingText"}
        includeLinearProgress={this.state.includeLinearProgress} isFoto={true} />
      <NavigatorFoto leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorFoto>
      <h1>
        <i className="mc-pin-check"></i>
        <label><Trans i18nKey="step3.summary">Resumen</Trans></label>
      </h1>

      <div className={stepClassName}>
      <Dialog open={this.state.showAlertModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {traduccionInputs}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizard}>
                <Trans i18nKey="dialog.accept">
                  Aceptar
                </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showModal} onClose={this.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title"><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.generatePDFWarning">
                Está apunto de generar una cartografía en alta resolución en formato PDF. El archivo generado puede llegar a ser pesado, en torno a 150MB. Antes de continuar, considere si su dispositivo o tarifa de datos le permite realizar esta descarga. Este proceso puede durar unos minutos.
              </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleClose}>
                <Trans i18nKey="dialog.close">
                  CERRAR
                </Trans>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={() => this.doRequest(parentState, conversorPDF)}>
                <i className="mc-download"></i>
                <label><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></label>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showModalDownload} onClose={this.handleCloseDownload} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title"><Trans i18nKey="dialog.PDFGenerated">PDF generado</Trans></DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.generatePDFCompleted.Parte1">Su PDF de Mapa a la Carta se ha generado correctamente.</Trans><br/>
            <Trans i18nKey="dialog.generatePDFCompleted.Parte2">Podrá descargarlo ahora o acceder más tarde copiando el siguiente enlace que estará</Trans>&nbsp;
              <b><Trans i18nKey="dialog.generatePDFCompleted.Parte3">disponible durante 7 días:</Trans></b>
              <br/><span id="urlPDF">{this.state.urlPDF}</span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  //this.copyToClipBoard();
                  let urlElement = document.getElementById('urlPDF');
                  if(urlElement && urlElement.innerText){
                    let tempSplit = urlElement.innerText.split("getPDFByID?printID=");
                    if(tempSplit.length === 2 && tempSplit[1].length === 18){
                      navigator.clipboard.writeText(tempSplit[1]);
                      this.handleShowSnackbar(false);
                    }
                  }
                }}>
                <i className="far fa-clipboard"></i>
                <span>&nbsp;<Trans i18nKey="dialog.copyID">COPIAR CÓDIGO</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  this.copyToClipBoard();
                  this.handleShowSnackbar(true);
                }}>
                <i className="far fa-clipboard"></i>
                <span>&nbsp;<Trans i18nKey="dialog.copyURL">COPIAR ENLACE</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={() => this.downloadPDF(this.state.urlPDF, this.state.idPedido)}>
                <i className="mc-download"></i>
                <label>&nbsp;<Trans i18nKey="dialog.download">DESCARGAR</Trans></label>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseDownload}>
              <Trans i18nKey="dialog.close">CERRAR</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showModalCart && !this.state.showModalRedirect} onClose={this.handleCloseCart} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title"><Trans i18nKey="step3.addCart">AÑADIR AL CARRITO</Trans></DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="step3.cartConfirmation">Este producto ya está añadido al carrito de la compra ¿quiere añadir más copias o dirigirse al carrito?</Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  this.addToShoppingCart(this.state);
                }}>
                <i className="far g-cartografia-mas"></i>
                <span>&nbsp;<Trans i18nKey="step3.add">AÑADIR</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  window.location.href = '/mapaalacarta/ShoppingCart';
                }}>
                <i className="far mc-basket"></i>
                <span>&nbsp;<Trans i18nKey="step3.toCart">IR AL CARRITO</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseCart}>
              <Trans i18nKey="dialog.close">CERRAR</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showModalRedirect} onClose={this.handleCloseRedirect} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title"><Trans i18nKey="step3.afterCart">INFORMACIÓN</Trans></DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="step3.orderAdded">Pedido añadido al carrito de la compra.</Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  window.location.href = '/mapaalacarta/ShoppingCart';
                }}>
                <i className="far mc-basket"></i>
                <span>&nbsp;<Trans i18nKey="step3.toCart">IR AL CARRITO</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  window.location.href = '/mapaalacarta';
                }}>
                <i className="far g-cartografia-mas"></i>
                <span>&nbsp;<Trans i18nKey="shoppingCart.addMoreMaps">Añadir más mapas</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseRedirect}>
              <Trans i18nKey="step3.stayPage">Permanecer en esta página</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.showModalBarCode} onClose={this.handleCloseBarCode} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle color="primary" id="alert-dialog-title">
            <Trans i18nKey="dialog.uploadImage">
              Subir Imagen
            </Trans>
            </DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.errorHeavyFile">
              La imagen que ha seleccionado excede el tamaño límite establecido</Trans> ({sizeImageCustomUnit})
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseBarCode}>
              <Trans i18nKey="dialog.back">
                Volver
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
        <Tour
          steps={steps}
          isOpen={isTourOpen}
          onRequestClose={this.closeTour} />
        <section className={sectionClassName}>
        <div className="color-flag">
          <div className="bg-color">
            {/*<Button name="marco_LIGHT_GREY" buttonClass={parentState.frameColor === '#E5E5E5'
                ? 'bg-light-grey active'
                : 'bg-light-grey'} onClick={this.setFrameColor}></Button> COLOR DEL MARCO */}
            <label><Trans i18nKey="step3.frameColor">Color del marco</Trans>
            </label>
            <Button name="marco_WHITE" buttonClass={parentState.frameColor === '#FFFFFF'
                ? 'bg-white active'
                : 'bg-white'} onClick={this.setFrameColor}></Button>
            <Button name="marco_BLUE" buttonClass={parentState.frameColor !== '#184962'
                ? 'bg-blue'
                : 'bg-blue active'} onClick={this.setFrameColor}></Button>
            <Button name="marco_RED" buttonClass={parentState.frameColor === '#952616'
                ? 'bg-red active'
                : 'bg-red'} onClick={this.setFrameColor}></Button>
            <Button name="marco_ORANGE" buttonClass={parentState.frameColor === '#f7a941'
                ? 'bg-orange active'
                : 'bg-orange'} onClick={this.setFrameColor}></Button>
            <Button name="marco_GREEN" buttonClass={parentState.frameColor === '#00a75d'
                ? 'bg-green active'
                : 'bg-green'} onClick={this.setFrameColor}></Button>
            <Button name="marco_GREY" buttonClass={parentState.frameColor === '#858584'
                ? 'bg-grey active'
                : 'bg-grey'} onClick={this.setFrameColor}></Button>
            <Button name="marco_BROWN" buttonClass={parentState.frameColor === '#946a43'
                ? 'bg-brown active'
                : 'bg-brown'} onClick={this.setFrameColor}></Button>
            <Button name="marco_CYAN" buttonClass={parentState.frameColor === '#5db3ae'
                ? 'bg-cyan active'
                : 'bg-cyan'} onClick={this.setFrameColor}></Button>
            <Button name="marco_PURPLE" buttonClass={parentState.frameColor === '#985fa4'
                ? 'bg-purple active'
                : 'bg-purple'} onClick={this.setFrameColor}></Button>
          </div>
        </div>
        <figure className='helpClass'>
          <a onClick={this.openTour}>
            <label id="download-tui-image" className="inputfile step3wizardPanelHelpButton">
              <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
            </label>
          </a>
        </figure>

<div className="texts-wizardPanel-step3 firstHelpStep">
  <div className="texts-row-poster">
    <div className="texts">
      <input type="text" id="titleStep2" name="textTitle" maxLength="35" placeholder={i18n.t('step2.title')+'*'} value={parentState.title} onChange={this.setText} required="required"/>
    </div>
    <div className="texts">
      <input type="text" name="textSubtitle" maxLength="45" placeholder={i18n.t('step2.subtitle')} value={parentState.subtitle} onChange={this.setText}/>
    </div>
    <div className="texts">
      <input type="text" id="textAuthor" name="textAuthor" maxLength="30" placeholder={i18n.t('step2.author')+'*'} value={parentState.author} onChange={this.setText} required="required" disabled={parentState.specialMapGeneration}/>
    </div>
  </div>
  {parentState.specialMapGeneration && (<div className="texts-row-poster">
  <div className="texts">
      <input type="text" id="textNipo" name="textNipo" maxLength="12" value={parentState.nipo} placeholder='NIPO* 123-45-678-9' onChange={this.setText} required="required"/>
    </div>
    <div className="texts">
      <input type="text" id="textISBN" name="textISBN" maxLength="17" value={parentState.isbn} placeholder='ISBN* 978-76-543-2101-2' onChange={this.setText} required="required"/>
    </div>
  </div>)}
  {parentState.specialMapGeneration && (<div className="texts-row-poster">
    <div className="texts">
      <input type="text" id="textDepositoLegal" name="textDepositoLegal" maxLength="12" placeholder={i18n.t('step2.depLegal')+'* M-25394-2022'} value={parentState.depositoLegal} onChange={this.setText} required="required"/>
    </div>
    <div className="texts">
      <div className={this.blockColor?'blockedColor':''} style={{position: 'relative'}}>
        {this.showSpan &&(<span className='placeholderFileInput'>{placeholderFile}</span>)}
        <input type="file" accept=".jpg,.png,.jpeg" id="imagenCodigoBarras" name="imagenCodigoBarras" onChange={this.handleChangeImageBarras} required={parentState.codigoBarras?false:'required'} style={{width: '100%'}}/>
        <button className='removeFileClass' onClick={this.clearCodigoBarras}>X</button>
      </div>
      <label><Trans i18nKey="step2.codBar">Código de Barras</Trans> (<label className="labelRed">*</label>)</label>
    </div>
  </div>)}
  {parentState.specialMapGeneration && (<div className="texts-row" style={{maxWidth: "700px", marginBottom: "5px"}}>
    <img src={parentState.codigoBarras} alt="*Barcode*" className="exampleBarcode"></img>
  </div>)}
</div>

<div className={"NewPDFPreviewClass " + (parentState.specialMapGeneration?"especialMapa ":"") + (parentState.orientation ==='Retrato'?'PrvwPort NewGenAspRatPortrait':'PrvwLand NewGenAspRatLandscape')} style={{borderColor: parentState.frameColor}}>
  <div className="PDFPREVIEW3">
    <div className="TITULO">
      <div className='titleSplit'><img className="fullWidthP" alt="Not found" src={LOGO}></img></div>
      <div className='titleMiddle'>
        <div className='titleHeight'>
          <div className="inputTitlePDF">{parentState.title}</div>
          <div className="inputSubTitlePDF cqwMR3">{parentState.subtitle}</div>
        </div>
      </div>
      <div className='titleSplit' align="right"><img className='halfWidthP' alt="Not found" src={this.LOGO_MAC}></img></div>
    </div>
      <div className="PDFPREVIEW6 MAPAASPECTRATIO">
        <table className="mapTableSquare fullWHP">
          <tbody><tr className='TborderHP'>
            <td className='TborderWP'></td>
            <td className='relpos TborderHP mshadowtop'>
              <div className='PDFCoordinatesLeft coordinatesCQW'>{conversorPDF.attributes.xCoordTopLeft}</div>
              <div className='PDFCoordinatesRight coordinatesCQW'>{conversorPDF.attributes.xCoordTopRight}</div>
            </td>
            <td className='TborderWP'></td>
          </tr><tr>
            <td className='TborderWP mshadowleft'>
              <div className='PDFCoordinatesTop coordinatesCQW'>{conversorPDF.attributes.yCoordTopLeft}</div>
              <div className='PDFCoordinatesBottom coordinatesCQW'>{conversorPDF.attributes.yCoordBotLeft}</div>
            </td>
            <td className='relpos2'>
              <div id="map2" className={aspectRatioClass}>{}</div>
              <MapPreview pluginListPreview={pluginListPreview} setParentState={this.setStateGlobal} parentState={parentState} M={M} centerX={parentState.center[0][0]} centerY={parentState.center[0][1]} mapa={parentState.mapa} scaleValue={parentState.scaleValue} isSimple={true} baseLayer='PNOA' conversorPDF={conversorPDF}></MapPreview>
              <div id="map3" className={aspectRatioClass}>{}</div>
              {this.pluginLegend && (this.pluginLegend)}
            </td>
            <td className='TborderWP mshadowrigth'>
              <div className='PDFCoordinatesTop coordinatesCQW'>{conversorPDF.attributes.yCoordTopRight}</div>
              <div className='PDFCoordinatesBottom coordinatesCQW'>{conversorPDF.attributes.yCoordBotRight}</div>
            </td>
          </tr><tr className='TborderHP'>
            <td className='TborderWP'></td>
            <td className='relpos TborderHP mshadowbottom'>
              <div className='PDFCoordinatesLeft coordinatesCQW'>{conversorPDF.attributes.xCoordBotLeft}</div>
              <div className='PDFCoordinatesRight coordinatesCQW'>{conversorPDF.attributes.xCoordBotRight}</div>
            </td>
            <td className='TborderWP'></td>
          </tr></tbody>
        </table>
      </div>
    <div className="LEYENDA1">
      <div className='bottomLegend pstr tableBottomText'>{conversorPDF.attributes.mathsDataCenter}</div>
      <div className='bottomLegend pstr tableBottomTextSmall'/>
      <div className='bottomLegend pstr tableBottomText tableRText'>{conversorPDF.attributes.agradecimientos}</div>
      {parentState.specialMapGeneration &&(<img className='CBCartela' src={parentState.codigoBarras} alt="*Bar Code*"></img>)}
    </div>
  </div>
</div>

        </section>
        <fieldset>
          {!parentState.specialMapGeneration &&(<legend>
            <div className="description-condiciones condiciones-legend-fieldset">
              <label><input name="condiciones" type="checkbox" checked={this.state.condiciones} onChange={this.handleInputChange}/>
              <label-link>
                <Trans i18nKey="step3.condicionesDeUso.Parte1">
                  Acepto las
                </Trans>&nbsp;
              </label-link>
              <a href={"/" + process.env.REACT_APP_CONTEXT + "condiciones.html"} target="_blank" rel="noopener noreferrer">
                <Trans i18nKey="step3.condicionesDeUso.Parte2">
                  condiciones de uso
                </Trans>
              </a>
              <label-link>
                &nbsp;<Trans i18nKey="step3.condicionesDeUso.Parte3">
                de Mapa a la Carta</Trans></label-link>

              </label>
            </div>
          </legend>)}
          <aside className={asideClassName}>
            <div className="panel-content">

              <h2 className="h2Custom">
                <label><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></label>
              </h2>
              <div className="description poster-padding">
                <label><Trans i18nKey="step3.pdfDescription1">Descargar mapa en formato pdf a máxima resolución.</Trans><br/><Trans i18nKey="step3.pdfDescription2">Este proceso puede durar unos minutos.</Trans></label>

              </div>
              <div className="download" style={{
                  "justifyContent" : "center"
                }}>
                {/* MARCAS de doblado */}

                <button className={(!this.state.condiciones && !parentState.specialMapGeneration)
                    ? "buttonDisabled"
                    : ""} onClick={this.handleShow} disabled={!this.state.condiciones && !parentState.specialMapGeneration}>
                  <i className="mc-download"></i>
                  <label><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></label>
                </button>
              </div>
              {!parentState.specialMapGeneration &&(<span>
              <h2 className="h2Custom">
                <label><Trans i18nKey="step3.buyPrint">Adquirir copia impresa</Trans></label>
              </h2>
              <div className="description poster-padding">
                <label><Trans i18nKey="step3.printDescription">Recibir, por vía postal, un duplicado del mapa que se ha generado.</Trans></label>
              </div>

              <div className="step3-paper-type">
                <h3><label><Trans i18nKey="step3.paperType">Tipo de papel</Trans></label></h3>

                <div className="button-check-row" style={{ justifyContent : "center" }}>
                  <div className="button-check poster-padding">
                    <button name="Normal" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("Normal")
                          ? "mc-normal active fa-2x"
                          : "mc-normal fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.normal">Normal</Trans></label>
                    <i className={this.state.paperType.includes("Normal")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>
                  
                  <div className="button-check poster-padding">
                    <button name="Aventura" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("Aventura")
                          ? "fas fa-umbrella active fa-2x"
                          : "fas fa-umbrella fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.resistent">Resistente</Trans></label>
                    <i className={this.state.paperType.includes("Aventura")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>

                  <div className="button-check poster-padding">
                    <button name="Fotografico" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("Fotografico")
                          ? "far fa-images active fa-2x"
                          : "far fa-images fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.photo">Fotográfico</Trans></label>
                    <i className={this.state.paperType.includes("Fotografico")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>

                  <div className="button-check poster-padding">
                    <button name="Rigido" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("Rigido")
                          ? "far fa-images active fa-2x"
                          : "far fa-images fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.rigid">Rígido</Trans></label>
                    <i className={this.state.paperType.includes("Rigido")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>
                </div>

              </div>
              <div className="packaging poster-padding">
                <div className="price">
                  <div className='smallPriceMargin'>
                    <input id="priceQuantity" type="number" defaultValue="1" min="1" max="999" onChange={this.functionUpdateCopies} onInput={this.functionUpdateCopies} className="units" style={{
                        width: "45px"
                      }}/>
                    <label className='noWrapClass'>{totalPrice} €</label>
                  </div>
                  <div style={{display:'flex'}}>
                    <button className={!this.state.condiciones
                        ? "buttonDisabled"
                        : ""} name="Compra" onClick={() => this.previuslyAddedToCart[this.state.paperType]?this.handleOpenCart():this.addToShoppingCart(this.state)} disabled={!this.state.condiciones} style={{width:'59%'}}>
                      <i className="mc-basket mc-1x"></i>&nbsp;
                      <label><Trans i18nKey="step3.addCart">AÑADIR AL CARRITO</Trans></label>
                    </button>
                    <button style={{ borderLeft: '2px solid white', width:'41%'}} className={!this.state.condiciones
                        ? "buttonDisabled noWrapClass"
                        : "noWrapClass"} name="Compra" onClick={() => this.tiendaVirtual(this.state)} disabled={!this.state.condiciones}>
                      <i className="far fa-euro-sign"></i>&nbsp;
                      <label><Trans i18nKey="step3.buy">COMPRAR</Trans></label>
                    </button>
                  </div>
                </div>
              </div>
              <div className="description-iva">
                <label><Trans i18nKey="step3.price">Precio sin IVA (envío no incluido)</Trans>
                </label>
                <label>
                <a href="https://www.cnig.es/condicionesCompra" target="blank">
                    <Trans i18nKey="step3.buyConditions">Condiciones de compra</Trans>
                  </a>
                  <label-link>
                    <Trans i18nKey="step3.virtualShop">de la Tienda Virtual</Trans>
                  </label-link>
                </label>

              </div>
              </span>)}
            </div>
          </aside>
        </fieldset>
      </div>

    </LayoutSimple>);
  }
}

export default Step2F;
